import React from "react"
import styles from "./Header.module.css"
import { Layout } from "antd"
import { Outlet } from "react-router-dom"
import { ProHeaderUI } from "./ProHeaderUI"

/**
 * ProHeader Layout Component
 * Uses <Outlet /> to render matched child routes from React Router
 * This is used in the routing configuration, not as a regular component with children props
 */
export const ProHeader = () => {
  return (
    <Layout className={styles.layout}>
      <ProHeaderUI hideOnMobile={true} />
      <Outlet />
    </Layout>
  )
}
